export const getPreloadedState = () => {
  const preloadedState = {};
  return preloadedState;
};